var render = function render() {
  var _vm$data$, _vm$data$2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pro_action_more flex justify-center"
  }, [_c('main', {
    staticClass: "flex items-center gap-2"
  }, [((_vm$data$ = _vm.data[0]) === null || _vm$data$ === void 0 ? void 0 : _vm$data$.type) === 'view' ? _c('i', {
    staticClass: "iconfont text-[22px] icon-base",
    class: _vm.data[0].icon,
    on: {
      "click": _vm.data[0].click
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.data[0].icon,
      expression: "!data[0].icon"
    }],
    staticClass: "pro_action_more_one text-[var(--primary-color)]"
  }, [_vm._v(" " + _vm._s(_vm.data[0].title) + " ")])]) : _vm._e(), ((_vm$data$2 = _vm.data[0]) === null || _vm$data$2 === void 0 ? void 0 : _vm$data$2.type) === 'edit' ? _c('i', {
    staticClass: "iconfont text-[18px] icon-base",
    class: _vm.data[0].icon,
    on: {
      "click": _vm.data[0].click
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.data[0].icon,
      expression: "!data[0].icon"
    }],
    staticClass: "pro_action_more_one text-[var(--primary-color)]"
  }, [_vm._v(" " + _vm._s(_vm.data[0].title) + " ")])]) : _vm._e(), _vm._moreList.length > 0 ? _c('div', [_c('Dropdown', {
    ref: "dropdownRef",
    attrs: {
      "visible": _vm.visible,
      "transfer": "",
      "placement": "bottom",
      "trigger": "custom"
    }
  }, [_c('span', {
    ref: "triggerRef"
  }, [_c('Icon', {
    staticClass: "icon-base",
    attrs: {
      "type": "ios-more",
      "size": 20
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.visible = !_vm.visible;
      }
    }
  })], 1), _c('DropdownMenu', {
    ref: "menuRef",
    staticClass: "p-2",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l(_vm._moreList, function (item, index) {
    return _c('DropdownItem', {
      key: index,
      staticClass: "pro_action_more_more_item",
      attrs: {
        "divided": item.divided,
        "disabled": item.disabled
      }
    }, [_c('ProActionMoreItem', {
      attrs: {
        "item": item
      },
      on: {
        "close-more": function ($event) {
          _vm.visible = false;
        }
      }
    })], 1);
  }), 1)], 1)], 1) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };